import { Divider } from '@mui/material'
import PropTypes from 'prop-types'

const TbxToolbarDivider = ({ sx = null }) => {
    return (
        <Divider
            orientation="vertical"
            sx={[{ backgroundColor: 'divider' }, ...(Array.isArray(sx) ? sx : [sx])]}
            flexItem
        />
    )
}

TbxToolbarDivider.propTypes = {
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
}

export default TbxToolbarDivider
